document.addEventListener('DOMContentLoaded', function() {
  const announcementBar = document.querySelector('.bsf-announcementbar');
  const marqueeWrapper = document.querySelector('.bsf-announcementbar-marquee-wrapper');
  const marqueeSlides = document.querySelector('.bsf-announcementbar-marquee-slides');
  let isMobile = window.innerWidth < 1150;

  function checkMobile() {
    return window.innerWidth < 1150;
  }

  function initializeMarquee() {
    if (!marqueeWrapper || !marqueeSlides) return;

    const clonedSlides = marqueeSlides.cloneNode(true);
    clonedSlides.classList.add('bsf-announcementbar-marquee-slides--cloned');
    
    marqueeWrapper.style.gap = '20px';
    marqueeWrapper.appendChild(clonedSlides);

    const containerWidth = marqueeSlides.offsetWidth;
    const gap = 20;
    const speed = 20;
    
    announcementBar.style.setProperty('--bsf-marquee-distance', `${containerWidth + gap}px`);
    announcementBar.style.setProperty('--bsf-marquee-speed', `${speed}s`);
    
    announcementBar.classList.add('bsf-announcementbar--marquee');
  }

  function disableMarquee() {
    const clonedSlides = document.querySelector('.bsf-announcementbar-marquee-slides--cloned');
    if (clonedSlides) {
      clonedSlides.remove();
    }

    marqueeWrapper.style.gap = '0px';
    announcementBar.classList.remove('bsf-announcementbar--marquee');
  }

  function setupDisplay() {
    if (isMobile) {
      initializeMarquee();
    } else {
      disableMarquee();
    }
  }

  function handleResize() {
    const wasMobile = isMobile;
    isMobile = checkMobile();
    
    if (wasMobile !== isMobile) {
      setupDisplay();
    } else if (isMobile && announcementBar.classList.contains('bsf-announcementbar--marquee')) {
      const containerWidth = marqueeSlides.offsetWidth;
      const gap = 20;
      const speed = 20;
      
      announcementBar.style.setProperty('--bsf-marquee-distance', `${containerWidth + gap}px`);
      announcementBar.style.setProperty('--bsf-marquee-speed', `${speed}s`);
    }
  }

  setupDisplay();
  
  requestAnimationFrame(() => {
    announcementBar.classList.remove('bsf-announcementbar--loading');
  });

  window.addEventListener('resize', handleResize);
});
